import * as THREE from "three";
import { Line2, LineMaterial, LineGeometry } from "three-stdlib";

export const makeLine = (
  positions: number[],
  color = 0xffffff,
  linewidth = 0.3
) => {
  const geometry = new LineGeometry();
  const material = new LineMaterial({
    color,
    linewidth,
    worldUnits: true,
    alphaToCoverage: true
  });

  const line = new Line2(geometry, material);
  line.scale.set(1, 1, 1);
  line.geometry.setPositions(positions);

  return line;
};

export const makeTrajectoryLine = (points: number[]) => {
  const lineGeometry = new LineGeometry();
  const lineMaterial = new LineMaterial({
    color: 0xffffff,
    linewidth: 0.3,
    worldUnits: true,
    alphaToCoverage: true,
    dashSize: 4,
    gapSize: 5,
    dashScale: 1
  });

  const line = new Line2(lineGeometry, lineMaterial);
  line.scale.set(1, 1, 1);
  line.geometry.setPositions(points);

  line.computeLineDistances();
  line.material.defines.USE_DASH = "";

  line.material.needsUpdate = true;

  return line;
};

export const getPositionAroundFocusTarget = (
  matrix4: THREE.Matrix4,
  distance: number
) => {
  const normalVectorFromFocus = new THREE.Vector3();

  matrix4.extractBasis(
    new THREE.Vector3(),
    new THREE.Vector3(),
    normalVectorFromFocus
  );

  const tangentVectorFromFocus = new THREE.Vector3();
  matrix4.extractBasis(
    new THREE.Vector3(),
    tangentVectorFromFocus,
    new THREE.Vector3()
  );

  let lookAtVector = new THREE.Vector3();
  lookAtVector = tangentVectorFromFocus.clone().sub(normalVectorFromFocus);

  lookAtVector.normalize().setLength(distance);

  return lookAtVector;
};

export const makeCone = (
  radius: number,
  height: number,
  color: number,
  opacity?: number
) => {
  const radialSegments = 32;
  const heightSegments = 1;
  const geometry = new THREE.ConeGeometry(
    radius,
    height,
    radialSegments,
    heightSegments
  );
  const material = new THREE.MeshBasicMaterial({
    color,
    opacity,
    transparent: opacity !== undefined
  });
  const cone = new THREE.Mesh(geometry, material);

  return cone;
};
